export const archivePolicyMenuGroupHeaderText = "GSd";
export default {archivePolicyMenuGroupHeaderText};